/* eslint-disable react/jsx-props-no-spreading */
import { Theme, useTheme } from '@mui/material/styles';
import { Dayjs } from 'dayjs';
import React from 'react';
import DateSelector from './DateSelector';
import { DateTimeCommonProps } from './DateTimeCommonProps';

export interface MonthlyDateSelectorProps
  extends Omit<DateTimeCommonProps, 'onAccept'> {
    disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange: (v: Dayjs | null) => void;
  value: Dayjs;
}

const handleMonthCSSChange = (month:number) => {
  switch (month) {
    case 0: // jan
      return '108';
    case 1: // Feb
      return '116';
    case 2: // march
      return '92';
    case 3: // april
      return '82';
    case 4: // may
      return '76';
    case 5: // june
      return '84';
    case 6: // july
      return '80';
    case 7: // august
      return '100';
    case 8: // sept
      return '128';
    case 9: // oct
      return '108';
    case 10:// nov
      return '124';
    case 11: // dec
      return '123';

    default:
      return '124';
  }
};

const styleSx = (theme: Theme, month: number) => ({
  '& .MuiInputBase-root': {
    width: 'fit-content',
  },
  '& .MuiInputBase-input': {
    maxWidth: `${handleMonthCSSChange(month)}px`,
  },
});

const MonthlyDateSelector = (props: MonthlyDateSelectorProps) => {
  const { onChange, value, disabled } = props;
  const theme = useTheme();

  return (
    <DateSelector
      inputFormat="MMMM YYYY"
      value={value}
      onChange={onChange}
      views={['year', 'month']}
      openTo="month"
      disabled={disabled}
      containerSx={{ ...styleSx(theme, value.month()) }}
    />
  );
};

export default MonthlyDateSelector;
